var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"customer-name",attrs:{"to":"/cpta/customers"}},[_vm._v("\n    "+_vm._s(_vm.$store.getters.getCurrentUser.customer_name)+"\n    "),_c('i',{staticClass:"el-icon-refresh"})])}
var staticRenderFns = []

export { render, staticRenderFns }